import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
// eslint-disable-next-line no-shadow
export var UnitType;
(function (UnitType) {
    UnitType["GALLONS"] = "gallons";
    UnitType["CUBIC_FEET"] = "cubic_feet";
    UnitType["CUBIC_METERS"] = "cubic_meters";
    UnitType["LITERS"] = "liters";
})(UnitType || (UnitType = {}));
export class UnitService {
    constructor() {
        this.units = {
            gallons: {
                type: UnitType.GALLONS,
                name: 'Gallons',
                short: 'gal',
                query: 'GALLONS',
                mult: 1.0,
                convert: this.unitConvertFn(UnitType.GALLONS),
            },
            cubic_feet: {
                type: UnitType.CUBIC_FEET,
                name: 'Cubic Feet',
                short: 'cu ft',
                query: 'CUBIC_FEET',
                mult: 0.133681,
                convert: this.unitConvertFn(UnitType.CUBIC_FEET),
            },
            cubic_meters: {
                type: UnitType.CUBIC_METERS,
                name: 'Cubic Meters',
                short: 'cm',
                query: 'CUBIC_METERS',
                mult: 0.00378541,
                convert: this.unitConvertFn(UnitType.CUBIC_METERS),
            },
            liters: {
                type: UnitType.LITERS,
                name: 'Liters',
                short: 'L',
                query: 'LITERS',
                mult: 3.78541,
                convert: this.unitConvertFn(UnitType.LITERS),
            },
        };
        this.current = new BehaviorSubject(UnitType.GALLONS);
        this.localStorageName = 'unit';
        const stored = localStorage.getItem(this.localStorageName);
        if (this.units[stored]) {
            this.current.next(stored);
        }
        else {
            localStorage.setItem(this.localStorageName, this.current.value.toString());
        }
    }
    get onChange() {
        return this.current.asObservable();
    }
    convertUnits(amount, from, to) {
        return (amount / this.units[from].mult) * this.units[to].mult;
    }
    convertFromCurrent(amount, unit) {
        return this.convertUnits(amount, unit, this.current.value);
    }
    convertToCurrent(amount, unit) {
        return this.convertUnits(amount, unit, this.current.value);
    }
    convertFromGallonsToCurrent(amount) {
        return this.convertUnits(amount, UnitType.GALLONS, this.current.value);
    }
    convertFromCurrentToGallons(amount) {
        return this.convertUnits(amount, this.current.value, UnitType.GALLONS);
    }
    get() {
        return this.units[this.current.value];
    }
    set(unit) {
        this.current.next(unit);
        localStorage.setItem(this.localStorageName, unit.toString().toLowerCase());
    }
    getAll() {
        return Object.values(this.units);
    }
    unitConvertFn(unit) {
        return ((amt, from) => this.convertUnits(amt, from, unit)).bind(this);
    }
}
UnitService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UnitService_Factory() { return new UnitService(); }, token: UnitService, providedIn: "root" });
